import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiEmailCampaignEmptyRecipientsError } from '@/core/error/transport/tmApiEmailCampaignEmptyRecipientsError'

export const emailCampaignEmptyRecipientsErrorRule: CustomErrorRule = {
  subCodes: ['email_campaign.empty_recipients'],
  klass: TmApiEmailCampaignEmptyRecipientsError,
}
